var React = require('react');

function LightningBolt (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#FFF"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M5.444 0l-.19 7.33h4.43c.276 0 .5.224.5.5 0 .08-.019.157-.054.227L5.064 18l.19-7.328H.815c-.276 0-.5-.224-.5-.5 0-.08.02-.157.055-.227L5.444 0z","transform":"translate(-773 -4157) translate(772.667 4155) translate(0 2)"}))))));
}

LightningBolt.defaultProps = {"width":"10","height":"18","viewBox":"0 0 10 18"};

module.exports = LightningBolt;

LightningBolt.default = LightningBolt;
